import { render, staticRenderFns } from "./error_400.vue?vue&type=template&id=53418510&"
import script from "./error_400.vue?vue&type=script&lang=js&"
export * from "./error_400.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports